export default {
   WEBSOCKET_URL: 'wss://chat.uro.tv/',
   AUTH_TOKEN: 'auth_token',
   ROOM_ID: "1",
   SITE: "aag",
   LANG: "ru",
}
